var React = require('react');

function Reorder (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M482.07,89.57c11.97,8.62,11.97,26.42,0,35.03l-97.86,70.38c-14.29,10.26-34.17.06-34.17-17.5v-19.02c0-10.5-38.92-19.01-86.93-19.01h-99.39c-50.64,0-91.67,41.06-91.67,91.67,0,17.87-14.49,32.36-32.36,32.36s-32.36-14.49-32.36-32.36c0-86.36,70.02-156.39,156.39-156.39h174.73c6.4,0,11.59-5.19,11.59-11.59v-26.45c0-17.59,19.88-27.78,34.17-17.53l97.86,70.4Z","key":0}),React.createElement("path",{"d":"M336.28,360.55c50.62,0,91.67-41.03,91.67-91.67,0-17.86,14.47-32.36,32.36-32.36s32.36,14.49,32.36,32.36c0,86.36-70.02,156.39-156.39,156.39h-174.73c-6.4,0-11.59,5.19-11.59,11.59v26.47c0,17.57-19.91,27.76-34.16,17.5l-97.87-70.4c-11.96-8.59-11.96-26.42,0-35.01l97.87-70.4c14.26-10.26,34.16-.06,34.16,17.53v19c0,10.5,38.92,19,86.93,19h99.39Z","key":1})]);
}

Reorder.defaultProps = {"id":"Layer_1","viewBox":"0 0 500 500"};

module.exports = Reorder;

Reorder.default = Reorder;
